import { render, staticRenderFns } from "./WhatsAppFloat.vue?vue&type=template&id=13a4725e&scoped=true"
import script from "./WhatsAppFloat.vue?vue&type=script&lang=js"
export * from "./WhatsAppFloat.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppFloat.vue?vue&type=style&index=0&id=13a4725e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a4725e",
  null
  
)

export default component.exports